import { z } from 'zod';

const hasMinimumLength = (value, minimum = 1) => typeof value === 'string' && value.trim().length >= minimum;
const getNonSpaceValue = (value) => (typeof value === 'string' ? value.replace(/\s+/g, '') : '');

export function formatPrimaryCarePostCode(value) {
  const normalizedValue = getNonSpaceValue(value).toUpperCase().trim();

  if (normalizedValue.length <= 3) {
    return normalizedValue;
  }

  return `${normalizedValue.slice(0, -3)} ${normalizedValue.slice(-3)}`;
}

export const primaryCareAddressFields = {
  address1: z.string().optional().nullable(),
  odsCode: z.string().optional().nullable(),
  nhsVerified: z.boolean().optional().nullable(),
  address2: z.string().optional().nullable(),
  city: z.string().optional().nullable(),
  postCode: z.string().optional().nullable(),
  addressEntryMethod: z.enum(['manual', 'lookup']).optional(),
};

export function validatePrimaryCareAddress(data, ctx) {
  if (!hasMinimumLength(data.postCode, 1)) {
    ctx.addIssue({
      code: z.ZodIssueCode.custom,
      message: 'Field Required',
      path: ['postCode'],
    });
  }

  if (!data.addressEntryMethod) {
    ctx.addIssue({
      code: z.ZodIssueCode.custom,
      message: 'Find and select an address to continue.',
      path: ['addressEntryMethod'],
    });
  }

  if (!hasMinimumLength(data.address1, 1)) {
    ctx.addIssue({
      code: z.ZodIssueCode.custom,
      message: 'Field Required',
      path: ['address1'],
    });
  }

  if (!hasMinimumLength(data.address2, 1)) {
    ctx.addIssue({
      code: z.ZodIssueCode.custom,
      message: 'Field Required',
      path: ['address2'],
    });
  }

  if (!hasMinimumLength(data.city, 1)) {
    ctx.addIssue({
      code: z.ZodIssueCode.custom,
      message: 'Field Required',
      path: ['city'],
    });
  }
}
